const categories = document.querySelectorAll('section[data-section-type="faq"]');
const firstCategory = categories[0];
const categoryList = document.querySelector('[faq-categories]');

categories.forEach(categorie => {
    // Create the buttons
    const title = categorie.dataset.title;
    const listItem = document.createElement("li");
    const button = document.createElement('a');
    button.classList.add('link', 'link--text', 'focus-inset');
    button.href = '#' + categorie.id;
    listItem.appendChild(button);
    button.innerHTML = title;
    categoryList.appendChild(listItem);
});

var faqQuestions = document.querySelectorAll(".faq-question");
faqQuestions.forEach(question => {
    question.addEventListener("toggle", function () {
        if (question.open) {
            history.pushState(null,null,'#'+ question.id);
        } else {
            history.pushState(null,null,' ');
        }

       })
});

if(window.location.hash) {
    const questionToOpen = document.querySelector('details' + window.location.hash);
    if (questionToOpen) {
        questionToOpen.open = true;
    }
}

class StickyFaqButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.onButtonClick.bind(this));
  
    }

    connectedCallback() {
        this.header = document.getElementById('shopify-section-header');
        this.headerBounds = {};
        this.currentScrollTop = 0;
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
  
    connectedCallback() {
      this.categories = document.querySelector('#faq-categories');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
  
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
      this.form = document.querySelector('#faq-categories');
      
  
  
      this.createObserver();
    }

    onButtonClick(e) {
      e.preventDefault();
        this.index = document.querySelector('#faq-categories');   
        location.href = "#";
        location.href = "#faq-categories";
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.categories);
    }
  
    isInViewport(elem) {
      var bounding = elem.getBoundingClientRect();
      return (
          bounding.top >= 0 &&
          bounding.left >= 0 &&
          bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
          bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
      );
    }
  
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (!this.preventReveal) {
  
        if (this.isInViewport(this.categories)) {
          requestAnimationFrame(this.hideForm.bind(this));
        } else {
          requestAnimationFrame(this.revealForm.bind(this));
        }
        
        
      } else {
        window.clearTimeout(this.isScrolling);
  
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
  
      }
    }
  
    hideForm() {
      this.classList.add('hidden');
  
    }
  
    revealForm() {
      this.classList.remove('hidden');
    }
  
    reset() {
      this.classList.add('hidden');
    }
  
  }
  
  customElements.define('sticky-faq-button', StickyFaqButton);